import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                d='M3 5.7H21.375M19.3333 5.7V20.4C19.3333 20.957 19.1182 21.4911 18.7353 21.8849C18.3525 22.2787 17.8332 22.5 17.2917 22.5H7.08333C6.54185 22.5 6.02254 22.2787 5.63966 21.8849C5.25677 21.4911 5.04167 20.957 5.04167 20.4V5.7M8.10417 5.7V3.6C8.10417 3.04305 8.31927 2.5089 8.70216 2.11508C9.08504 1.72125 9.60435 1.5 10.1458 1.5H14.2292C14.7707 1.5 15.29 1.72125 15.6728 2.11508C16.0557 2.5089 16.2708 3.04305 16.2708 3.6V5.7M10.1458 10.95V17.25M14.2292 10.95V17.25'
                fill='transparent'
                stroke='currentColor'
                strokeWidth='2.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </SvgIcon>
    );
});
